/*********************** Custom JS for Boost AI Search & Discovery  ************************/
function checkOptionIsAvailable(option, data) {
    let variants = data.variants;
    let is_available = false;
    for (let i = 0; i < variants.length; i++) {
        if (variants[i].merged_options.includes('color:' + option) && variants[i].available) {
            return true;
        }
    }
    return is_available;
}

const boost_sd_customize = {
    update: (componentRegistry) => {
        // Update image Intrinsic size
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'Modify Product Item',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        // Start customization--------------------------------------------
                        let productData = element.getParams().props.product;
                        let itemEls = document.querySelectorAll('.boost-sd__product-item[data-product-id="' + productData.id + '"]');
                      
                        const currentPath = window.location.pathname;
                        const origin = window.location.origin;
                      
                        itemEls.forEach(function(el) {
                            let itemEl = el;

                            // Start Custom Link Path
                            if (currentPath.includes('collections') && !currentPath.includes('products')) {
                              let itemLinkEls = itemEl.querySelectorAll('.boost-sd__product-link');
                              itemLinkEls.forEach(function(el) {
                                let linkEl = el;
                                linkEl.href = currentPath + '/products/' + productData.handle;
                              })
                            }

                            // let newTitlePrice = document.createElement('div');
                            // let newVendorRating = document.createElement('div');
                            // let newColorTitle = document.createElement('div');
                            // let itemTitleEl = itemEl.querySelector('.boost-sd__product-title').cloneNode(true);
                            // let itemPriceEl = itemEl.querySelector('.boost-sd__product-price').cloneNode(true);
                            // let itemRatingEl = itemEl.querySelector('.boost-sd__integration-product-rating').cloneNode(true);
                            // let itemVendorEl = itemEl.querySelector('.boost-sd__product-vendor').cloneNode(true);
                            // if(newVendorRating && newTitlePrice.innerHTML == ''){
                            //   newVendorRating.classList.add('boost-sd__product-vendor-and-rating');
                            //   newVendorRating.appendChild(itemVendorEl);
                            //   newVendorRating.appendChild(itemRatingEl);
                            //   if(itemEl.querySelector('.boost-sd__product-vendor-and-rating') == null){
                            //     itemEl.querySelector('.boost-sd__product-info').insertAdjacentElement('afterbegin',newVendorRating);
                            //   }
                            // }
                            // if(newTitlePrice && newTitlePrice.innerHTML == ''){
                            //   newTitlePrice.classList.add('boost-sd__product-title-and-price');
                            //   newTitlePrice.appendChild(itemTitleEl);
                            //   newTitlePrice.appendChild(itemPriceEl);
                            //   if(itemEl.querySelector('.boost-sd__product-title-and-price') == null){
                            //     itemEl.querySelector('.boost-sd__product-vendor-and-rating').insertAdjacentElement('afterend',newTitlePrice);
                            //   }
                            // }
                            // if(newColorTitle && newColorTitle.innerHTML == ''){
                            //   let defaultColor = productData.options_with_values.find(({name}) => 'color').values[0].title;
                            //   newColorTitle.classList.add('boost-sd__product-color-title');
                            //   newColorTitle.innerHTML = '<label>Color: </label><span class="amazing">'+ defaultColor +'</span><span class="temp">'+ defaultColor +'</span>';
                            //   if(itemEl.querySelector('.boost-sd__product-swatch') && itemEl.querySelector('.boost-sd__product-color-title') == null){
                            //     itemEl.querySelector('.boost-sd__product-swatch').insertAdjacentElement('afterbegin',newColorTitle);
                            //     let itemSwatchOptions = itemEl.querySelectorAll('.boost-sd__product-swatch-option');
                            //     for (let i = 0; i < itemSwatchOptions.length; i++) {
                            //       itemSwatchOptions[i].addEventListener("mouseover", function(){
                            //         let hoverColorLabel = this.querySelector('label').textContent;
                            //         itemEl.querySelector('.boost-sd__product-color-title .temp').textContent = hoverColorLabel;
                            //         itemEl.querySelector('.boost-sd__product-color-title .amazing').style.display = "none";
                            //         itemEl.querySelector('.boost-sd__product-color-title .temp').style.display = "inline-block";
                            //       });
                            //       itemSwatchOptions[i].addEventListener("mouseleave", function(){
                            //         itemEl.querySelector('.boost-sd__product-color-title .amazing').style.display = "inline-block";
                            //         itemEl.querySelector('.boost-sd__product-color-title .temp').style.display = "none";
                            //       });
                            //       itemSwatchOptions[i].addEventListener("click", function(){
                            //         let hoverColorLabel = this.querySelector('label').textContent;
                            //         itemEl.querySelector('.boost-sd__product-color-title .amazing').textContent = hoverColorLabel;
                            //         itemEl.querySelector('.boost-sd__product-color-title .amazing').style.display = "inline-block";
                            //         itemEl.querySelector('.boost-sd__product-color-title .temp').style.display = "none";
                            //       });
                            //     }
                            //   }
                            // }
                            // Custom labels
                            let productTags = productData.tags;
                            //console.log('productData', productData);
                            let productCustomLabels = '';
                            let productCustomLabelArr = [];
                            for (let i = 0; i < productTags.length; i++) {
                                if (productTags[i] == 'badge:bestseller' && !productCustomLabelArr.includes('badge:bestseller')) {
                                    productCustomLabelArr.push('badge:bestseller');
                                    productCustomLabels = `<div style="z-index: 2;" class="boost-sd-custom-badge">
                                                            <div class="badges-badge-bestseller">
                                                              <p>Most Loved</p>
                                                            </div>
                                                          </div>`;
                                }
                                if (productTags[i] == 'badge:New Arrival' && !productCustomLabelArr.includes('badge:New Arrival')) {
                                    productCustomLabelArr.push('badge:New Arrival');
                                    productCustomLabels = `<div style="z-index: 2;" class="boost-sd-custom-badge">
                                                            <div class="badges-badge-new-arrival">
                                                              <p>New</p>
                                                            </div>
                                                          </div>`;
                                }
                                if (productTags[i] == 'badge:staff-pick' && !productCustomLabelArr.includes('badge:staff-pick')) {
                                    productCustomLabelArr.push('badge:staff-pick');
                                    productCustomLabels = `<div style="z-index: 2;" class="boost-sd-custom-badge">
                                                            <div class="badges-badge-staff-pick">
                                                              <p>Staff Pick</p>
                                                            </div>
                                                          </div>`;
                                }
                                if (productData.percent_sale_min > 0) {
                                    productCustomLabelArr.push('badge:Sale');
                                    productCustomLabels = `<div style="z-index: 2;" class="boost-sd-custom-badge">
                                                            <div class="badges-badge-sale">
                                                              <p>${productData.percent_sale_min}% off</p>
                                                            </div>
                                                          </div>`;
                                }
                                if (productTags[i] == 'badge:bundle' && !productCustomLabelArr.includes('badge:bundle')) {
                                    productCustomLabelArr.push('badge:bundle');
                                    productCustomLabels = `<div style="z-index: 2;" class="boost-sd-custom-badge">
                                                            <div class="badges-badge-bundle">
                                                              <p>Bundle & Save</p>
                                                            </div>
                                                          </div>`;
                                }
                                if (productTags[i] == 'badge:New Color' && !productCustomLabelArr.includes('badge:New Color')) {
                                    productCustomLabelArr.push('badge:New Color');
                                    productCustomLabels = `<div style="z-index: 2;" class="boost-sd-custom-badge">
                                                            <div class="badges-badge-new-color">
                                                              <p>New Color</p>
                                                            </div>
                                                          </div>`;
                                }
                            }
                            if (productCustomLabelArr.length > 0 && itemEl.querySelector('.boost-sd-custom-badge') == null) {
                                itemEl.querySelector('.boost-sd__product-image').insertAdjacentHTML('beforeend', productCustomLabels);
                            }
                            // End custom labels
                        });
                        // End-------------------------------------------------------------
                    } catch (e) {
                        console.error(e);
                    }
                },
            }),
        });
        /* end Custon Product Item */
        /* start Custom Swatches on Product List #218972 */
        componentRegistry.useComponentPlugin('ProductSwatch', {
            name: 'Modify Product Swatches',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        // Reupdate variant image by using metafield value
                        let productData = null;
                        let propOptions = null;
                        let swatchEls = null;
                        if (element.getParams().props.isQuickView) {
                            productData = element.getParentElm().getParams().props.productData;
                            propOptions = element.getParams().props.options;
                            swatchEls = document.querySelectorAll('.boost-sd__quick-view[product-id="' + productData.id + '"]');
                        } else {
                            productData = element.getParentElm().getParams().props.data;
                            propOptions = element.getParams().props.options;
                            swatchEls = document.querySelectorAll('.boost-sd__product-item[data-product-id="' + productData.id + '"]');
                        }

                        let productMetafields = productData.metafields;
                        let productMetaVariants = null;
                        // let productImages = productData.images_info;
                        // let productImageVariants = null;
                        for (let i = 0; i < productMetafields.length; i++) {
                            if (productMetafields[i].key == "swatch_image") {
                                productMetaVariants = JSON.parse(productMetafields[i].value);
                            }
                        }
                        for (let i = 0; i < propOptions.length; i++) {
                            if (typeof productMetaVariants[propOptions[i].value] == 'undefined') continue;
                            let optionHex = productMetaVariants[propOptions[i].value]['hex'];
                            let optionImageBg = null;
                            if (productMetaVariants[propOptions[i].value]['image_url'] !== 'undefined') {
                                optionImageBg = productMetaVariants[propOptions[i].value]['image_url'];
                            }

                            if (optionImageBg !== null) {
                                if (element.getParams().props.isQuickView) {
                                    swatchEls.forEach(function(el) {
                                        let swatchEl = el;
                                        let itemQuickViewOptionElLabel = swatchEl.querySelector('[value="' + propOptions[i].value + '"] + label');
                                        if (itemQuickViewOptionElLabel != null && itemQuickViewOptionElLabel != undefined) {
                                            itemQuickViewOptionElLabel.style.backgroundImage = "url(" + optionImageBg + ")";
                                        }
                                    });
                                } else {
                                    swatchEls.forEach(function(el) {
                                        //element.getParams().props.options[i].image = optionImageBg;
                                        let swatchEl = el;
                                        let itemOptionElLabel = swatchEl.querySelector('[value="' + propOptions[i].value + '"] + label');

                                        if (itemOptionElLabel != null && itemOptionElLabel != undefined) {
                                            itemOptionElLabel.style.backgroundImage = "url(" + optionImageBg + ")";
                                            // Fallback to hex code if image is null
                                            if (optionImageBg == null) {
                                                itemOptionElLabel.style.backgroundColor = optionHex;
                                            }
                                        }
                                    });
                                }
                            }
                            if (!checkOptionIsAvailable(propOptions[i].value, productData)) {
                                swatchEls.forEach(function(el) {
                                    let swatchEl = el;
                                    let itemOptionEl = swatchEl.querySelector('[value="' + propOptions[i].value + '"]');
                                    if (itemOptionEl != null && itemOptionEl != undefined) {
                                        itemOptionEl.disabled = "disabled";
                                    }
                                });
                            }
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }
            })
        });
    },
};
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    boost_sd_customize.update,
]);
// const customizeMethodFulfilled = (componentRegistry) => {
//     componentRegistry.useModulePlugin("FilterAPI", {
//         name: "custom collection page",
//         apply(builder) {
//             builder.on("methodFulfilled", "get", (props) => {
//                 customFunction(props);
//             });
//         },
//     });
//     componentRegistry.useModulePlugin("SearchAPI", {
//         name: "custom search page",
//         apply(builder) {
//             builder.on("methodFulfilled", "searchInCollection", (props) => {
//                 if (props.result && props.result.hasOwnProperty("filter")) {
//                     customFunction(props);
//                 }
//             });
//         },
//     });
// };
// window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customizeMethodFulfilled]);
// window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat((registry) => {
//     registry.useModulePlugin("RecommendationAPI", {
//         name: "Recommendation API before call",
//         apply(builder) {
//             builder.on("methodFulfilled", "get", (payload) => {
//                 // Custom code goes here
//                 //console.log(payload);
//                 customFunction(payload, '.slick-slide:not(.slick-cloned)');
//             });
//         },
//     });
// });
// async function customFunction(props) {
//     const datas = props.result.products || [];
//     for (const data of datas) {
//         let itemHtml = '';
//         let itemReviewHtml =
//             '<div class="boost-sd__integration-product-rating">' +
//             '<div class="grid-view-item__reviews"><div class="yotpo bottomLine" data-appkey="......." data-domain="' +
//             boostSDAppConfig.shop.domain +
//             '" data-product-id="' +
//             data.id +
//             '" data-product-models="' +
//             data.id +
//             '" data-name="' +
//             data.title +
//             '" data-url="{{itemUrl}}" data-description="{{itemDescription}}" data-bread-crumbs="{{itemTags}}"></div></div>' +
//             '</div>';
//         itemHtml = itemReviewHtml;
//         let itemDescription = data.description ? data.description : "";
//         let productItemUrl = Shopify.routes.root + 'products/' + data.handle;
//         itemDescription = itemDescription.substr(0, itemDescription.indexOf("##highlights##"));
//         itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
//         itemHtml = itemHtml.replace(/{{itemTags}}/g, data.tags.join(";"));
//         itemHtml = itemHtml.replace(/{{itemUrl}}/g, productItemUrl);
//         let itemEl = await waitForElm(`.boost-sd__product-item[id='${data.id}']`);
//         if (itemEl && !itemEl.querySelector('.grid-view-item__reviews')) {
//             itemEl.querySelector('.boost-sd__product-info .boost-sd__product-title').insertAdjacentHTML('afterEnd', itemHtml);
//         }
//     }
//     if (typeof Yotpo !== "undefined" && typeof yotpoWidgetsContainer !== "undefined") {
//         yotpoWidgetsContainer.initWidgets(); /*var api = new Yotpo.API(yotpo);  api.refreshWidgets();*/
//     }
// }

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });
        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}
let sizeValue = '';
let colorValue = '';
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'Modify Product Item',
            enabled: true,
            apply: () => ({
                afterRender: (element) => {
                    try {
                        let data = element.getParams().props.product;
                        //console.log('data', data);
                        let productId = data.id;
                        if (data?.split_product) {
                            productId = data.variant_id;
                        }
                        let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                        if (productItem) {
                            // Get query params
                            let paramsString = window.location.search;
                            let searchParams = new URLSearchParams(paramsString);
                            // console.log('data: ', data.options_with_values);
                            // console.log('paramsString: ', paramsString);
                            // Get list of selected colors
                            let colors = searchParams.getAll('pf_opt_color');
                            let sizes = searchParams.getAll('pf_opt_size');
                            let variantId = '';
                            let colorIndex = data.options_with_values.findIndex(function(e) {
                                return e.name == 'color';
                            });
                            let sizeIndex = data.options_with_values.findIndex(function(e) {
                                return e.name == 'size';
                            });

                            // For hiding Swatch Element on Products in Grid.
                            const currentPath = window.location.pathname;
                            const hideSwatches = ['layers', 'sale']; // incase we have multiple collections in the future

                            if (currentPath.includes('layers') || currentPath.includes('sale')) {
                              const swatch = productItem.querySelector('.boost-sd__product-swatch');
                              swatch.style.display = 'none';
                            }
                          
                            if (colors.length > 0 && sizes.length > 0) {
                                for (let i = 0; i < colors.length; i++) {
                                    colorValue = 'color:' + colors[i];
                                    for (let j = 0; j < sizes.length; j++) {
                                        sizeValue = 'size:' + sizes[j];
                                        for (let w = 0; w < data.variants.length; w++) {
                                            const variantData = data.variants[w];
                                            if (variantData.merged_options[colorIndex] == colorValue && variantData.merged_options[sizeIndex] == sizeValue) {
                                                variantId = variantData.id;
                                            }
                                            if (variantId != '') break;
                                        }
                                    }
                                }
                            } else if (sizes.length > 0) {
                                for (let i = 0; i < sizes.length; i++) {
                                    sizeValue = 'size:' + sizes[i];
                                    for (let j = 0; j < data.variants.length; j++) {
                                        const variant = data.variants[j];
                                        for (let sizeIndex = 0; sizeIndex < variant.merged_options.length; sizeIndex++) {
                                            if (variant.merged_options[sizeIndex] == sizeValue) {
                                                variantId = variant.id;
                                                break;
                                            }
                                        }
                                        if (variantId != '') {
                                            break;
                                        }
                                    }
                                }
                            } else if (colors.length > 0) {
                                for (let i = 0; i < colors.length; i++) {
                                    colorValue = 'color:' + colors[i];
                                    for (let j = 0; j < data.variants.length; j++) {
                                        const variant = data.variants[j];
                                        for (let colorIndex = 0; colorIndex < variant.merged_options.length; colorIndex++) {
                                            if (variant.merged_options[colorIndex] == colorValue) {
                                                variantId = variant.id;
                                                break;
                                            }
                                        }
                                        if (variantId != '') {
                                            break;
                                        }
                                    }
                                }
                            }
                            // console.log('FINAL: ', variantId, data);

                            if (currentPath.includes('collections') && !currentPath.includes('products')) {
                                const productUrl = productItem.querySelectorAll('.boost-sd__product-link');
                                if (productUrl) {
                                    productUrl.forEach(function(url) {
                                        // const currentPath = window.location.pathname;
                                        // const currentUrl = Shopify.routes.root + currentPath + '/products/' + data.handle;
                                        const currentUrl = currentPath + '/products/' + data.handle;
                                        url.setAttribute('href', currentUrl + '?variant=' + variantId);
                                    });
                                }
                            }
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            }),
        });
    }
]);
if (window.boostSDAppConfig) { window.boostSDAppConfig.integration = Object.assign({ wishlists: 'king' }, window.boostSDAppConfig.integration || {}); }